// extracted by mini-css-extract-plugin
export var academicsOffset = "default-layout-module--academics-offset--4960e";
export var active = "default-layout-module--active--c55e9";
export var annualEvents = "default-layout-module--annual-events--8a2a5";
export var annualNews = "default-layout-module--annual-news--e03d5";
export var annualProjects = "default-layout-module--annual-projects--3c88d";
export var backgroundImage = "default-layout-module--background-image--a91cd";
export var btnClose = "default-layout-module--btn-close--1474f";
export var btnOutlineLsuGold = "default-layout-module--btn-outline-lsu-gold--3c27c";
export var btnOutlineLsuPurple = "default-layout-module--btn-outline-lsu-purple--c4ba6";
export var btnPrimary = "default-layout-module--btn-primary--d763c";
export var btnSecondary = "default-layout-module--btn-secondary--6c6b0";
export var defaultOffset = "default-layout-module--default-offset--e138a";
export var doubleOffset = "default-layout-module--double-offset--5d547";
export var eventBlog = "default-layout-module--event-blog--0be9a";
export var h1 = "default-layout-module--h1--279df";
export var h2 = "default-layout-module--h2--7cfe2";
export var h3 = "default-layout-module--h3--9664e";
export var h4 = "default-layout-module--h4--4b958";
export var h5 = "default-layout-module--h5--6b016";
export var h6 = "default-layout-module--h6--0ebd0";
export var hover = "default-layout-module--hover--ec7fa";
export var menu = "default-layout-module--menu--e9dc8";
export var navLink = "default-layout-module--nav-link--b5f0b";
export var navbarDark = "default-layout-module--navbar-dark--b24fc";
export var navbarNav = "default-layout-module--navbar-nav--a56f8";
export var navbarToggler = "default-layout-module--navbar-toggler--db73d";
export var navbarTogglerIcon = "default-layout-module--navbar-toggler-icon--a275d";
export var newsArticle = "default-layout-module--news-article--c511e";
export var newsEventsEvents = "default-layout-module--news-events-events--f76db";
export var newsEventsNews = "default-layout-module--news-events-news--fc5fb";
export var pageItem = "default-layout-module--page-item--9b6fc";
export var pageLink = "default-layout-module--page-link--e7885";
export var projectPost = "default-layout-module--project-post--aa9ce";
export var textLight = "default-layout-module--text-light--bda13";
export var textLsuLightGold = "default-layout-module--text-lsu-light-gold--cf3b9";
export var textWhite = "default-layout-module--text-white--36a21";
export var topNavigation = "default-layout-module--top-navigation--f403d";
export var underline = "default-layout-module--underline--71ab3";